import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5075169a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-secondary",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item has-text-white has-text-weight-semibold app-navbar-item" }, "Wildlive Portal", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-end" }, null, -1))
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = {
  key: 0,
  class: "navbar-item has-text-warning has-text-weight-bold"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item has-text-white has-text-weight-semibold app-navbar-item" }, "Home", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item has-text-white has-text-weight-semibold app-navbar-item" }, "Projects", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item has-text-white has-text-weight-semibold app-navbar-item" }, "Station setups", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item has-text-white has-text-weight-semibold app-navbar-item" }, "Capture events", -1))
const _hoisted_15 = { class: "navbar-item" }
const _hoisted_16 = { class: "buttons" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "button is-light has-text-white has-text-weight-semibold" }, "Connecting server", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Logout", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Login", -1))
const _hoisted_28 = [
  _hoisted_27
]

import { ref } from "vue";

const __default__ = {
  name: "TheHeader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showBurgerItems = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          role: "button",
          class: "navbar-burger",
          "aria-label": "menu",
          "aria-expanded": "true",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showBurgerItems.value = !showBurgerItems.value))
        }, _hoisted_7)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-menu", { 'is-active': showBurgerItems.value }])
      }, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_ctx.$keycloak_isAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " ! admin ! "))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/showArea/projects",
            class: ""
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/stationsetupsoverview" }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/showArea/captureevent" }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (!_ctx.$store.getters['keycloak/getStatusReady'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_ctx.$store.getters['keycloak/getStatusAuthenticated'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("a", {
                            href: _ctx.$keycloakLogoutLink(),
                            class: "button is-success has-text-white has-text-weight-semibold"
                          }, _hoisted_24, 8, _hoisted_22)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("a", {
                            href: _ctx.$keycloakLoginLink(),
                            class: "button is-primary has-text-white has-text-weight-semibold"
                          }, _hoisted_28, 8, _hoisted_26)
                        ]))
                  ]))
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})